// extracted by css-extract-rspack-plugin
var _1 = "SymbolsPicker-m_buttonDiv-yTAk_BeT";
var _2 = "SymbolsPicker-m_emojiButton-kGPprue8 common-m_resetButton-o3oKAnUN";
var _3 = "SymbolsPicker-m_symbolsBody-IwVIkFmw";
var _4 = "SymbolsPicker-m_symbolsButton-YONb1SHF common-m_resetButton-o3oKAnUN";
var _5 = "SymbolsPicker-m_symbolsContainer-vx1dq7Ib";
var _6 = "SymbolsPicker-m_symbolsFooter-hN3lBaT3";
var _7 = "SymbolsPicker-m_symbolsSearch-U4ZCIPLm";
var _8 = "SymbolsPicker-m_symbolsWindow-NhWwnTzY";
var _9 = "SymbolsPicker-m_wrapperDiv-giHUNpEx";
export { _1 as "buttonDiv", _2 as "emojiButton", _3 as "symbolsBody", _4 as "symbolsButton", _5 as "symbolsContainer", _6 as "symbolsFooter", _7 as "symbolsSearch", _8 as "symbolsWindow", _9 as "wrapperDiv" }
